import React, { useEffect, useState } from "react";
import Icon from "@/components/Icon";
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from "@/context/AuthContext";
import { APP_FLOW_MENU } from "@/constants/token.const";
import { useTranslation } from "react-i18next";
import { usePlatform } from "@/hooks/usePlatform";

export function Breadcrumb({ className, ...props }) {

    const location = useLocation();
    const { getMenu } = useAuth();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [breadCrumbs, setBreadCrumbs] = useState([]);

    useEffect(() => {
        let list = location.pathname.split("/");
        setBreadCrumbs((prevState) => {
            prevState = [];
            list.forEach((item, index) => {
                if (item) {
                    if (item === 'admin') {
                        prevState = [
                            ...prevState,
                            {
                                path: '/admin',
                                menu: <>
                                    <div className={'px-2'}><Icon name={'ChevronRight'} size={16} color={'#94a3b8'} /></div>
                                    <span className={'bc-item text-sm text-muted-foreground'}>{t('admin')}</span>
                                </>
                            }
                        ];
                    } else if (item === 'profile') {
                        prevState = [
                            ...prevState,
                            {
                                path: '/profile',
                                menu: <>
                                    <div className={'px-2'}><Icon name={'ChevronRight'} size={16} color={'#94a3b8'} /></div>
                                    <span className={'bc-item text-sm text-muted-foreground'}>{t('profile')}</span>
                                </>
                            }
                        ];
                    } else if (item === 'rp') {
                        prevState = [
                            ...prevState,
                            {
                                path: '/rp',
                                menu: <>
                                    <div className={'px-2'}><Icon name={'ChevronRight'} size={16} color={'#94a3b8'} /></div>
                                    <span className={'bc-item text-sm text-muted-foreground'}>{t('rp')}</span>
                                </>
                            }
                        ];
                    } else {
                        const menu = findMenu(item);
                        if (menu) {
                            prevState = [
                                ...prevState,
                                {
                                    path: menu.path ?? './1',
                                    menu: <>
                                        <div className={'px-2'}><Icon name={'ChevronRight'} size={16} color={'#94a3b8'} /></div>
                                        <span className={'bc-item text-sm text-muted-foreground'}>{(i18n.language === "mn" ? menu.name : menu.name2)  ?? item}</span>
                                    </>
                                }
                            ];
                        }
                    }
                }
            })

            return prevState;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    const findMenu = (param) => {
        let module = {};
        getMenu().forEach((item) => {
            if (item.moduleid === param) {
                module = {
                    name: item.name,
                    name2: item.name2,
                    pc: item.moduleid,
                    path: item.moduleid
                }
            }
            item.submenus.forEach((subMenu) => {
                if (subMenu.processcode === param) {
                    module = {
                        name: subMenu.processname,
                        name2: subMenu.processname2,
                        pc: subMenu.processcode,
                        path: item.moduleid + '/' + subMenu.processcode
                    };
                }
            })
        })

        if (Object.keys(module).length === 0) {
            const paths = location.pathname.split("/").filter(Boolean);
            const dynamicFlowIndex = paths.indexOf("pf000501");
            const isDynamicFlowDetail = dynamicFlowIndex !== -1 && paths[dynamicFlowIndex + 1] === param;
            const isDynamicProcessView = paths.length === 2 && paths[0] === "pf" && paths[1] === param;
            if (isDynamicFlowDetail || isDynamicProcessView) {
                const data = JSON.parse(sessionStorage.getItem(APP_FLOW_MENU)) ?? [];
                const item = data.find((item) => {
                    return item.linkid === param && (item.typeid === 3 || item.typeid === "3")
                });

                return {
                    name: item?.name ?? param,
                    name2: item?.name2 ?? item?.name ?? param,
                    pc: "pf000501",
                    path: "pf/pf000501/" + param,
                };
            }

            if (param === 'si') {
                return null;
                // module = {
                //     name: 'Ажилтны цэс',
                //     name2: 'Menu',
                //     pc: 'si',
                //     path: '/si'
                // };
            } else if (param === 'si000301') {
                return null;
                // module = {
                //     name: 'Симулэйт',
                //     name2: 'Simulate',
                //     pc: 'si000301',
                //     path: ''
                // };
            } else if (param === 'si000201') {
                return null;
                // module = {
                //     name: 'Симулэйт',
                //     name2: 'Simulate',
                //     pc: 'si000301',
                //     path: ''
                // };
            } else {
                const data = JSON.parse(sessionStorage.getItem(APP_FLOW_MENU)) ?? null;

                const item = data.filter((item) => {
                    return item.linkid === param
                });

                if (item && item.length > 0) {
                    module = {
                        name: item[0].name,
                        name2: item[0].name2,
                        pc: 'si000301',
                        path: '/si/si000301/' + param
                    };
                }
            }
        }
        return module
    }

    const onClickBreadcrumb = (item) => {
        if (item.path === '/admin') {
            navigate('/admin');
            return;
        }
        if (item.path === '/si') {
            navigate('/si');
            return;
        }
        const splitPaths = location.pathname.split("/");

        if (splitPaths.includes('admin')) {
            if (location.pathname !== '/admin') {
                navigate('/admin/' + item.path)
            } else {
                navigate('/admin');
            }
        } else {
            navigate('/si/' + item.path)
        }
    }

    useEffect(() => {
    }, [breadCrumbs])

    const { isMobile } = usePlatform();

    return (
        (location.pathname !== '/dashboard' && !location.pathname.startsWith('/dashboard/') && !isMobile) && <div className='flex items-center py-4'>
            <div
                className={'cursor-pointer'}
                onClick={() => {
                    navigate('/')
                }}
            >
                <Icon name={'Home'} size={18} color={'#64748b'} />
            </div>
            {
                breadCrumbs.map((item, index) => {
                    return index + 1 !== breadCrumbs.length ? <div
                        className={'cursor-pointer flex'}
                        onClick={() => { onClickBreadcrumb(item) }}
                        key={index}>{item.menu}
                    </div> : <div
                        className={'bc-current flex'}
                        key={index}>{item.menu}
                    </div>
                })
            }
        </div>
    );
}